export abstract class AbstractSessionRecorder {
  protected isInit = false
  protected isRecording = false
  protected isEnabled = false
  protected settings?: any

  /**
   * Cleanly stop the recorder. Safe to call multiple times (idempotent).
   */
  public abstract stop(): Promise<void>

  /**
   * Begin recording the current session. Safe to call multiple times (idempotent).
   */
  public abstract start(): Promise<void>

  /**
   * Get the current session URL
   */
  public abstract getSessionUrl?(callback: (url: string) => void): void

  /** Returns true if the recorder is currently recording a session. */
  public isActive(): boolean {
    return this.isRecording
  }
}
